module.exports = require('./helpers/bundle-url').getBundleURL('bLxZJ') + "white-logo.e3fd0f08.png" + "?" + Date.now();